import React from "react";
import { Box, IBoxProps } from ".";

/**
 * Interface to add more properties
 */
export interface ISidebarBaseProps extends IBoxProps {
	/**
	 * If the sidebar is open or not
	 *
	 * Default: true
	 */
	open?: boolean;
	/**
	 * If the sidebar should be fixed or not
	 */
	fixed?: boolean;
	/**
	 * If it hides to the right.
	 *
	 * Default: false
	 */
	hidesRight?: boolean;
	/**
	 * The breakpoint at which it should start hiding
	 *
	 * Default: ""
	 */
	breakpoint?: number;
}

export type ISidebarProps = ISidebarBaseProps & Omit<JSX.IntrinsicElements["div"], "ref">;

/**
 * A box that is basically a styled div
 */
export const Sidebar = ({open, fixed, hidesRight, breakpoint, ...props}: ISidebarProps) => {
	const toResponsive = (def: any, value: any): any => {
		if (!breakpoint || breakpoint <= 0) {
			return def;
		}
		const arr = [def];
		for (let i = 0; i < breakpoint - 1; i++) {
			arr.push(null);
		}
		arr.push(value);
		return arr;
	};
	return (
		<Box {...{
			...props,
			position: toResponsive(fixed === true ? "fixed" : "absolute", "relative"),
			top: 0,
			bottom: 0,
			left: hidesRight ? undefined : 0,
			right: hidesRight ? 0 : undefined,
			m: 0,
			height: "100%",
			minWidth: 0,
			transition: "transform 300ms",
			transform: open ? "translateX(0)" : toResponsive(hidesRight ? "translateX(100%)" : "translateX(-100%)", "translateX(0)"),
		}} />
	);
};
